export const selectUserRole = (state) => state.users.currentUser.role;

export const selectIsAdmin = (state) => selectUserRole(state) === "admin";
export const selectIsHost = (state) => state.users.currentUser.isHostConfirmed;
